module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('navbar', [_c('button', {
    staticClass: "navbar-toggler mobile-sidebar-toggler d-lg-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileSidebarToggle
    }
  }, [_vm._v("\n        ☰\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand text-center",
    attrs: {
      "href": "/#/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/logo_inline.png",
      "alt": "Dowhile",
      "width": "140"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav d-md-down-none"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-toggler sidebar-toggler",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.sidebarMinimize
    }
  }, [_vm._v("☰")])])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "id": "dropdownMenuButton",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "d-md-down-none"
  }, [_vm._v("\n                  " + _vm._s((_vm.user.empresa != null ? _vm.user.empresa.nomeFantasia + ' - ' : '')) + " " + _vm._s(_vm.user.nome) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right",
    attrs: {
      "aria-labelledby": "dropdownMenuButton"
    }
  }, [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": _vm.changePassword
    }
  }, [_c('i', {
    staticClass: "fa fa-key"
  }), _vm._v(" Alterar senha")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Sair")])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav ml-auto"
  }, [_c('li', {
    staticClass: "nav-item d-md-down-none"
  }, [_c('a', {
    staticClass: "nav-link navbar-toggler aside-menu-toggler",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.asideToggle
    }
  }, [_vm._v("☰")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-623f3b6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 875
// module chunks = 1